var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "m-subheader" }, [
      _c("div", { staticClass: "d-flex align-items-center" }, [
        _c("div", { staticClass: "mr-auto" }, [
          _c(
            "ul",
            { staticClass: "m-subheader__breadcrumbs m-nav m-nav--inline" },
            [
              _c(
                "li",
                { staticClass: "m-nav__item" },
                [
                  _c("router-link", { attrs: { to: { name: "home" } } }, [
                    _c("span", { staticClass: "m-nav__link-text" }, [
                      _c("i", { staticClass: "m-nav__link-icon la la-home" })
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("li", { staticClass: "m-nav__separator" }, [
                _vm._v("\n\t\t  \t\t\t\t>\n\t\t  \t\t\t")
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "m-nav__item" }, [
                _c("a", { staticClass: "m-nav__link", attrs: { href: "" } }, [
                  _c("span", { staticClass: "m-nav__link-text" }, [
                    _vm._v(
                      "\n\t\t  \t\t\t\t\t\t" +
                        _vm._s(
                          _vm._f("titleize")(
                            _vm._f("translate")("system_administration")
                          )
                        ) +
                        "\n\t\t  \t\t\t\t\t"
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "m-nav__separator" }, [
                _vm._v("\n\t\t  \t\t\t\t>\n\t\t  \t\t\t")
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "m-nav__item" }, [
                _c("a", { staticClass: "m-nav__link", attrs: { href: "" } }, [
                  _c("span", { staticClass: "m-nav__link-text" }, [
                    _vm._v(
                      "\n\t\t  \t\t\t\t\t\t" +
                        _vm._s(
                          _vm._f("titleize")(
                            _vm._f("translate")("general_configuration")
                          )
                        ) +
                        "\n\t\t  \t\t\t\t\t"
                    )
                  ])
                ])
              ])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "m-content", attrs: { id: "content" } },
      [
        _c("div", { staticClass: "col-xl-12" }, [
          _c(
            "div",
            {
              staticClass:
                "m-portlet m-portlet--bordered-semi m-portlet--widget-fit m-portlet--full-height m-portlet--skin-light"
            },
            [
              _c("div", { staticClass: "m-portlet__head" }, [
                _c("div", { staticClass: "m-portlet__head-caption" }, [
                  _c("div", { staticClass: "m-portlet__head-title" }, [
                    _c(
                      "h3",
                      { staticClass: "m-portlet__head-text m--font-light" },
                      [
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              _vm._f("titleize")(
                                _vm._f("translate")("general_configuration")
                              )
                            ) +
                            "\n                "
                        )
                      ]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "m-portlet__body" }, [
                _c("div", { staticClass: "m-widget17" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "m-widget17__stats" }, [
                    _c(
                      "div",
                      {
                        staticClass: "m-widget17__items m-widget17__items-col1"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "m-widget17__item",
                            on: {
                              click: function($event) {
                                return _vm.openNetworkModal()
                              }
                            }
                          },
                          [
                            _vm._m(1),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "m-widget17__subtitle" },
                              [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(
                                      _vm._f("titleize")(
                                        _vm._f("translate")("network")
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "m-widget17__desc" }, [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(
                                    _vm._f("titleize")(
                                      _vm._f("translate")(
                                        "network_configuration"
                                      )
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "m-widget17__items m-widget17__items-col2"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "m-widget17__item",
                            on: {
                              click: function($event) {
                                return _vm.openReloadModal()
                              }
                            }
                          },
                          [
                            _vm._m(2),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "m-widget17__subtitle" },
                              [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(
                                      _vm._f("titleize")(
                                        _vm._f("translate")("restart")
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "m-widget17__desc" }, [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(
                                    _vm._f("titleize")(
                                      _vm._f("translate")("restart_components")
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "m-widget17__items m-widget17__items-col2"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "m-widget17__item",
                            on: {
                              click: function($event) {
                                return _vm.openUpdateModal()
                              }
                            }
                          },
                          [
                            _vm._m(3),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "m-widget17__subtitle" },
                              [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(
                                      _vm._f("titleize")(
                                        _vm._f("translate")("update")
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "m-widget17__desc" }, [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(
                                    _vm._f("titleize")(
                                      _vm._f("translate")("update_server")
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "m-widget17__stats" }, [
                    _c(
                      "div",
                      {
                        staticClass: "m-widget17__items m-widget17__items-col2"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "m-widget17__item",
                            on: {
                              click: function($event) {
                                return _vm.openBackupModal()
                              }
                            }
                          },
                          [
                            _vm._m(4),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "m-widget17__subtitle" },
                              [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(
                                      _vm._f("titleize")(
                                        _vm._f("translate")("backup")
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "m-widget17__desc" }, [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(
                                    _vm._f("titleize")(
                                      _vm._f("translate")(
                                        "backup_configuration"
                                      )
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "m-widget17__items m-widget17__items-col2"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "m-widget17__item",
                            on: {
                              click: function($event) {
                                return _vm.restoreAction()
                              }
                            }
                          },
                          [
                            _vm._m(5),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "m-widget17__subtitle" },
                              [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(
                                      _vm._f("titleize")(
                                        _vm._f("translate")("restore")
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "m-widget17__desc" }, [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(
                                    _vm._f("titleize")(
                                      _vm._f("translate")("restore_server")
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "m-widget17__items m-widget17__items-col1"
                    })
                  ])
                ])
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "s-modal",
          {
            attrs: {
              id: "network_modal",
              title: _vm._f("capitalize")(
                _vm._f("translate")("network_configuration")
              )
            }
          },
          [
            _c("s-network-configuration", {
              attrs: { slot: "body" },
              slot: "body"
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "s-modal",
          {
            attrs: {
              id: "reload_modal",
              title: _vm._f("capitalize")(
                _vm._f("translate")("restart_components")
              )
            }
          },
          [
            _c("s-reload-configuration", {
              attrs: { slot: "body" },
              slot: "body"
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "s-modal",
          {
            attrs: {
              id: "update_modal",
              title: _vm._f("capitalize")(_vm._f("translate")("update"))
            }
          },
          [_c("s-update", { attrs: { slot: "body" }, slot: "body" })],
          1
        ),
        _vm._v(" "),
        _c(
          "s-modal",
          {
            attrs: {
              id: "sync_modal",
              title: _vm._f("capitalize")(_vm._f("translate")("sync"))
            }
          },
          [_c("s-sync", { attrs: { slot: "body" }, slot: "body" })],
          1
        ),
        _vm._v(" "),
        _c(
          "s-modal",
          {
            attrs: {
              id: "restore_modal",
              title: _vm._f("capitalize")(_vm._f("translate")("restore"))
            }
          },
          [_c("s-restore", { attrs: { slot: "body" }, slot: "body" })],
          1
        ),
        _vm._v(" "),
        _c(
          "s-modal",
          {
            attrs: {
              id: "backup_modal",
              title: _vm._f("capitalize")(_vm._f("translate")("backup"))
            }
          },
          [_c("s-backup", { attrs: { slot: "body" }, slot: "body" })],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "m-widget17__visual m-widget17__visual--chart m-portlet-fit--top m-portlet-fit--sides m--bg-primary",
        staticStyle: { background: "#2c375b!important" }
      },
      [_c("div", { staticClass: "m-widget17__chart" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "m-widget17__icon" }, [
      _c("i", { staticClass: "flaticon-map m--font-brand" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "m-widget17__icon" }, [
      _c("i", { staticClass: "flaticon-refresh m--font-success" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "m-widget17__icon" }, [
      _c("i", { staticClass: "flaticon-paper-plane m--font-info" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "m-widget17__icon" }, [
      _c("i", { staticClass: "flaticon-download m--font-success" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "m-widget17__icon" }, [
      _c("i", { staticClass: "flaticon-warning-sign m--font-info" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-163f4510", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-163f4510","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/admin/configuration/All.vue
// module id = 658
// module chunks = 0 1 71